<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<div class="page-container top-fix resize-index min-height-100vh verify-sms-form-spinner-wrapper" [class.not-clickable]="isSpinnerActive" #spinnerDiv>
  <div class="white-card position-rel">
    <div class="login-content start-column-vertical-centered-container column-gap-2p5em">
      <!--          back button-->
      <div class="entrance-back-button bold500" (click)="changePage(previousPage)">
        <app-all-icons class="icon-size-1p5em" [iconNameAndStyling]="'back.svg'"></app-all-icons>
        Back
      </div>
      <!--          verify-->
      <div
        *ngIf="page === 'verify'"
        class="stretched-aligned-column-container column-gap-1p5625em"
        [ngClass]="{ 'no-propagation opacity0p5 no-cursor' : isFormDisabled }">
        <div class="flex-column column-gap-0p625em text-align-center">
          <div class="login-title line-height-120 ">Check your {{verificationMethodsMap[currentVerificationMethod]}}
          </div>
          <div class="font-2em">Enter the code sent to
            <span class="bold500 align-text">{{beforeLastFour}}</span>
            <span>{{lastNumbs}}</span>
          </div>
        </div>

        <form (ngSubmit)="withSpinner(onSubmit())" id="wf-form-Login" name="wf-form-Login" data-name="Login" method="get"
              class="column-gap-1p25em vertical-container-simple">
          <app-input
            data-qa="Code"
            class="entrance-input"
            [(input)]="code"
            [type]="'tel'"
            [placeholder]="'Enter code'"
            [regularExpression]="regExpService.positiveNumbersOnlyIncludeZero"
            [maxLength]="6"
            [autofocus]="true"
            [required]="true"
            (inputChange)="submitIfSixDigits()"
            (keydown)="preventEnter($event)"
          />
          <input type="submit" value="Log in" data-wait="Please wait..." class="w-button submit-button"
            [disabled]="!code">
        </form>

        <div *ngIf="countdownInterval" class="text-align-center font-2em main-color bold500">You can resend message or
          change verification method in
          <span>{{countdownSeconds}} seconds</span>
        </div>
        <a *ngIf="!countdownInterval" (click)="changeVerifyPage('changeMethod')"
          class="text-align-center font-2em main-color bold500 clickable">Resend code or change verification method</a>
      </div>
      <!--          change method-->
      <div *ngIf="page === 'changeMethod'" class="centered-column-container width-100pcnt column-gap-0p625em">
        <div class="login-title">Verification options</div>
        <div class="column-gap-1p5625em width-100pcnt centered-column-container">
          <div class="font-2em">Your phone number is
            <span class="seconds">{{maskedPhoneNumber}}</span>
          </div>

          <div class="width-100pcnt column-gap-0p625em vertical-container-simple">
            <app-verify-method *ngFor="let method of verificationMethods" [method]="method"
              [isActive]="currentVerificationMethod === method.id"
              (changeMethod)="withSpinner(changeVerifyMethod($event))"></app-verify-method>
          </div>
        </div>
      </div>
      <!--          need help-->
      <div class="flex flex-col items-center justify-center">
        <span>Need help? Contact us at</span>
        <a data-qa="support-email" class="main-8" [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>
      </div>
    </div>
  </div>
</div>
